import { Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {AppService} from "@irb/app.service";
import {IUserDetails} from "@irb/app.model";

@Component({ standalone: false,
    selector: 'mmc-irb-footer-dialog',
    templateUrl: './mmc-footer-dialog.component.html',
    styleUrls: ['./mmc-footer-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MMCFooterDialogComponent implements OnInit {
    now: Date = new Date();

    constructor(public dialogRef: MatDialogRef<MMCFooterDialogComponent>, public as: AppService) {}

    ngOnInit() {
    }

    close() {
        this.dialogRef.close();
    }


}
